// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/icons/v2/24/24-send.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/assets/images/loaders/100-watch.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `submit-button {
  display: flex;
  flex-direction: row;
  cursor: pointer !important;
  user-select: none;
  height: 56px;
  background-color: #122AFF;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px 0 16px;
  border: 2px solid #122AFF;
  border-radius: 6px;
}
submit-button div.label {
  font-family: "Incinet Semi Bold", sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  color: #FFFFFF;
}
submit-button div.icon {
  width: 24px;
  height: 24px;
  background-color: #FFFFFF;
}
submit-button div.icon-submit {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
submit-button[locked=true] div.icon {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}`, "",{"version":3,"sources":["webpack://./src/aptl/components/submit-button/submit-button.scss","webpack://./src/aptl/components/styles/_mixins.scss","webpack://./src/aptl/components/styles/_colors.scss","webpack://./src/aptl/components/styles/_styles.scss"],"names":[],"mappings":"AAIA;EC+BE,aAAA;EACA,mBAAA;EAsBA,0BAAA;EACA,iBAAA;EDpDA,YAAA;EACA,yBEPU;EFQV,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AADF;AAGE;ECXA,4CAAA;EEiDA,eAAA;EACA,kBAAA;EACA,mBAAA;EHtCE,cEhBO;AFkBX;AACE;EACE,WAAA;EACA,YAAA;EACA,yBEtBO;AFuBX;AACI;EACE,mDAAA;AACN;AAII;EACE,mDAAA;AAFN","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
